import {
    ViewEncapsulation,
    Component,
    HostBinding,
    ElementRef,
    inject,
    input,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --background: rgba(var(--background-rgb, var(--bazis-text-color-rgb, 0, 0, 0)), 0.065); --height: inherit; --width: initial; --width-percent: 100%; --margin-top: 0; --margin-bottom: 0; --animation-duration: initial; border-radius: var(--border-radius, inherit); display: block; width: var(--width, var(--width-percent)); max-width: 100%; height: var(--height); margin-top: var(--margin-top); margin-bottom: var(--margin-bottom); background: var(--background); line-height: 10px; user-select: none; pointer-events: none; } span { display: inline-block; } :host(.bazis-skeleton_in-media) { --margin-bottom: 0; --margin-top: 0; margin-left: 0; margin-right: 0; height: 100%; } :host(.bazis-skeleton_inline) { --margin-bottom: 0; --margin-top: 0; display: inline-block; vertical-align: middle; } :host(.bazis-skeleton--animated) { position: relative; } :host(.bazis-skeleton--animated.bazis-skeleton_shimmer) { background: linear-gradient(to right, var(--background-1-point, rgba(var(--background-rgb, var(--bazis-text-color-rgb, 0, 0, 0)), 0.065)) 8%, var(--background-2-point, rgba(var(--background-rgb, var(--bazis-text-color-rgb, 0, 0, 0)), 0.135)) 18%, var(--background-3-point, rgba(var(--background-rgb, var(--bazis-text-color-rgb, 0, 0, 0)), 0.065)) 33%); background-size: 800px 104px; animation: shimmer var(--animation-duration) infinite linear; animation-fill-mode: forwards; } :host(.bazis-skeleton--animated.bazis-skeleton_shineLines) { animation: shineLines var(--animation-duration) infinite ease-in-out; } @keyframes shimmer { 0% { background-position: -400px 0; } 100% { background-position: 400px 0; } } @keyframes shineLines { 0%, to { opacity: 0.3; } 50% { opacity: 0.5; } }`,
);

@Component({
    selector: 'bazis-skeleton',
    template: `<span>&nbsp;</span>`,
    // styleUrls: ['skeleton.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false,
})
export class SkeletonElement implements OnInit {
    public el = inject(ElementRef);

    readonly animated = input<boolean>(true);

    readonly animatedType = input<'shineLines' | 'shimmer'>('shineLines');

    readonly inline = input<boolean>(false);

    readonly inMedia = input<boolean>(false);

    readonly height = input<number | string>();

    readonly width = input<number | string>();

    readonly widthP = input<number | string>();

    readonly top = input<number | string>();

    readonly bottom = input<number | string>();

    @HostBinding('class') get skeletonStyle() {
        return {
            ['bazis-skeleton--animated']: this.animated(),
            ['bazis-skeleton_in-media']: this.inMedia(),
            ['bazis-skeleton_inline']: this.inline(),
            [`bazis-skeleton_${this.animatedType()}`]: !!this.animatedType(),
        };
    }

    @HostBinding('style.--margin-top') get topPosition() {
        const top = this.top();
        if (top !== undefined) return `${top}px`;
    }

    @HostBinding('style.--margin-bottom') get bottomPosition() {
        const bottom = this.bottom();
        if (bottom !== undefined) return `${bottom}px`;
    }

    @HostBinding('style.--height') get heightSize() {
        const height = this.height();
        if (height !== undefined) return `${height}px`;
    }

    @HostBinding('style.--width') get widthSize() {
        const width = this.width();
        if (width !== undefined) return `${width}px`;
    }

    @HostBinding('style.--width-percent') get widthSizeInPercent() {
        const widthP = this.widthP();
        if (widthP !== undefined) return `${widthP}%`;
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
